import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Book from '../views/Book.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Book',
    component: Book
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
